import { isValidFileName } from "../../../../../common/utils/isValidFileName";
import { ICreateAuditoresUseCase } from "../../../presentation/useCases/create/create_auditores_servicos_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";

export class CreateAuditoresUseCase implements ICreateAuditoresUseCase {
  constructor(private readonly repository: IAuditorRepository) {}

  async createAuditores(
    Nome: string | null,
    TelFixo: string | null,
    TelCelular: string | null,
    Email: string | null,
    OutrasInformacoes: string | null,
    Cidade: string | null,
    Arquivo1: File | null,
    Arquivo2: File | null,
    Arquivo3: File | null,
    Arquivo4: File | null,
    Arquivo5: File | null,
    TipoAuditor: number
  ): Promise<number> {
    const arquivoNome1 = Arquivo1 !== null ? Arquivo1.name : null;
    const arquivoNome2 = Arquivo2 !== null ? Arquivo2.name : null;
    const arquivoNome3 = Arquivo3 !== null ? Arquivo3.name : null;
    const arquivoNome4 = Arquivo4 !== null ? Arquivo4.name : null;
    const arquivoNome5 = Arquivo5 !== null ? Arquivo5.name : null;

    const response = await this.repository.createAuditores(
      Nome,
      TelFixo,
      TelCelular,
      Email,
      OutrasInformacoes,
      Cidade,
      Arquivo1,
      Arquivo2,
      Arquivo3,
      Arquivo4,
      Arquivo5,
      arquivoNome1,
      arquivoNome2,
      arquivoNome3,
      arquivoNome4,
      arquivoNome5,
      TipoAuditor
    );
    return response.idAuditor;
  }
}
